import React from 'react';
import styled from 'styled-components';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { BrokerJob } from '@warehouse/object-browser/feature-broker';

const Ellipsis = styled('span')({
	display: 'block',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
});

/** The Broker's content-addressed job id; the full value is in the tooltip since it rarely fits. */
export function JobIdCell({ row }: GridRenderCellParams<BrokerJob, string>) {
	return <Ellipsis title={row.jobId}>{row.jobId}</Ellipsis>;
}
